import _ from 'underscore';
import { Base } from './base';
import { IValidationRule } from '../types';

/**
 * Define validator which checks whether a field is empty when required
 * @param {boolean} allowSpace - whether to allow space in the value
 * @param {I18nModel} i18n - provides a getString callback which will be called
 * with args 'Validation_NotEmpty_Required_Field'
 */
class Required extends Base implements IValidationRule {
  allowSpace: boolean;

  constructor(allowSpace: boolean, i18n: I18nModel) {
    super(i18n);

    this.allowSpace = !!allowSpace;
    this.message = i18n.getString('Validation_NotEmpty_Required_Field');
  }

  isValidValue(value: unknown): boolean {
    return (typeof value === 'bigint') || _.isFinite(value)
       || !_.isEmpty(!this.allowSpace && _.isString(value) ? (value as string).trim() : value);
  }
}

/**
 * Create a required validator instance
 * @param {boolean} allowSpace - whether to allow space in the value
 * @param {I18nModel} i18n - provides getString callback
 * @returns {IValidationRule} - required validator instance
 */
export function required(allowSpace: boolean, i18n: I18nModel): IValidationRule {
  return new Required(allowSpace, i18n);
}
